import { Alert, Box, Button, Stack } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { exitShowcase, isShowcaseGuest } from "./showcase";

/** Shown across the app while a visitor is exploring the public read-only demo. */
export default function ShowcaseBanner() {
  if (!isShowcaseGuest()) {
    return null;
  }

  return (
    <Box sx={{ position: "sticky", top: 0, zIndex: 1200, width: "100%" }}>
      <Alert
        severity="info"
        icon={<VisibilityIcon fontSize="inherit" />}
        sx={{
          borderRadius: 0,
          alignItems: "center",
          "& .MuiAlert-message": { width: "100%" },
        }}
      >
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={1}
          sx={{ alignItems: { sm: "center" }, justifyContent: "space-between" }}
        >
          <span>
            You&apos;re exploring a <strong>read-only demo</strong> of a class mid-game. Look
            around every page; nothing you do here is saved.
          </span>
          <Stack direction="row" spacing={1} sx={{ flexShrink: 0 }}>
            <Button
              size="small"
              variant="contained"
              color="success"
              onClick={() => exitShowcase("/home#waitlist")}
            >
              Join the waitlist
            </Button>
            <Button size="small" variant="outlined" onClick={() => exitShowcase()}>
              Exit demo
            </Button>
          </Stack>
        </Stack>
      </Alert>
    </Box>
  );
}
